import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import lodash from 'lodash';
import { TRANSFORMER_BREAKERS } from '../../../../appConstants';
import { Autocomplete } from '@material-ui/lab';
import { createSelector } from 'reselect';
import { TextField } from '@material-ui/core';

interface ICircuitBreakerSelectorProps {
    required ?: boolean;

    fullWidth ?: boolean;

    value : number | null;

    phase ?: number | null;

    onChange : (circuit : number | null) => void;
}

interface ICircuitBreakerSelectorState {
}

export default class CircuitBreakerSelector extends React.Component<ICircuitBreakerSelectorProps, ICircuitBreakerSelectorState> {
    constructor(props : ICircuitBreakerSelectorProps) {
        super(props);
        this.state = {
        };
    }

    private readonly getPhase = (state : ICircuitBreakerSelectorState, props : ICircuitBreakerSelectorProps) => props.phase;
    private readonly getValue = (state : ICircuitBreakerSelectorState, props : ICircuitBreakerSelectorProps) => props.value;

    private readonly getOptions = createSelector([
        this.getPhase,
    ], (phase) => {
        const options = lodash
            .chain(TRANSFORMER_BREAKERS)
            .filter((x, cphase) => !phase || Number(cphase) === phase)
            .flatMap(x => x)
            .uniq()
            .map(n => ({
                label: `${n} A`,
                value: n,
            }))
            .sortBy(x => x.value)
            .value();

        return options;
    });

    private readonly getSelectedValue = createSelector([
        this.getValue,
        this.getOptions,
    ], (
        value,
        options,
    ) => {
        if (value) {
            const circuit = options.find(x => x.value === value);

            if (circuit) {
                return {
                    label: `${circuit.value} A`,
                    value: circuit.value,
                };
            } else {
                return {
                    label: `${value} A`,
                    value: value,
                };
            }
        }

        return null;
    });

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : number | string | null | {
        label : string;
        value : number;
    }) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof value === 'string') {
            this.props.onChange(Number(value));
        } else if (typeof value === 'number') {
            this.props.onChange(value);
        } else {
            this.props.onChange(value?.value ?? null);
        }
    };

    public readonly render = () => {
        const { required, fullWidth } = this.props;
        const options = this.getOptions(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl fullWidth={fullWidth}>
                <Autocomplete
                    freeSolo
                    options={options}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={(option : {
                        label : string;
                        value : number;
                    } | null) => option?.label ?? `${option}`}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    fullWidth={fullWidth}
                    renderInput={params => <TextField error={required && !value} {...params} label='Circuit Breaker' />}
                />
            
            </FormControl>
        );
    };
}
